import passwordModalModule from "./passwordModalModule"

passwordModalModule.service("passwordModalService", ["expiredPasswordWarningModal", "changePasswordModal", "authenticationService", function (expiredPasswordWarningModal, changePasswordModal, authenticationService) {
    this.openExpiredPasswordWarningModal = (credentials) => {
        let remainingDays = authenticationService.getPasswordRemainingDays()
        if(remainingDays) {
            return expiredPasswordWarningModal(remainingDays, changePasswordModal, credentials)
        }
    }

    this.openChangePasswordModal = (credentials) => {
        return changePasswordModal(credentials)
    }
}])